import { render, staticRenderFns } from "./VerifyMyIdentity.vue?vue&type=template&id=4be72383&"
import script from "./VerifyMyIdentity.vue?vue&type=script&lang=js&"
export * from "./VerifyMyIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports